import { render } from "./SchoolEditTable.vue?vue&type=template&id=20efd153&scoped=true&ts=true"
import script from "./SchoolEditTable.vue?vue&type=script&lang=ts"
export * from "./SchoolEditTable.vue?vue&type=script&lang=ts"

import "./SchoolEditTable.vue?vue&type=style&index=0&id=20efd153&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20efd153"]])

export default __exports__